import React, { useEffect } from 'react';
import arrow from '../../assets/images/arrow_back.svg';
import Header from '../../assets/images/Header.svg';
import LicenseIcon from '../../assets/icons/Vector.svg';
import CustomINput from '../../components/common/InputField/InputField';
import CustomDatepicker from '../../components/common/datePicker/DatePicker';
import CustomDropDown from '../../components/common/dropdown/Dropdown';
import Icon from '../../assets/icons/info.svg';
import IconArrow from '../../assets/icons/Vector (1).svg';
import PersonalInfo from './PersonalInfo';
import Professional from './Professional';
import DocumentUpload from './DocumentUpload';
import CompleteForm from './CompleteForm';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import './PhysicianForm.css';
import apiService from '../../services/apiService';
import Arabic from '../../assets/images/Arabic-line.svg';
import shatho from '../../assets/images/stethoscope-line.svg';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const dummyOptions = [
  { value: 'Cardiology', label: 'Cardiology' },
  { value: 'Dermatology', label: 'Dermatology' },
  { value: 'Neurology', label: 'Neurology' },
  { value: 'Pediatrics', label: 'Pediatrics' },
];
const practitionerType = [
  { value: 'Internal-Private Sector', label: 'Internal-Private Sector' },
  { value: 'MOH Employe', label: 'MOH Employee' },
];

const PhysicianForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = React.useState(null);
  const [selectedTab, setSelectedTab] = React.useState(1); // Track the selected tab
  const [loading, setLoading] = React.useState(false);
  const [checkDisabled, setCheckDisabled] = React.useState(false);
  const [practitionerLevel, setPractitionerLevel] = React.useState(null);
  const [middle, setMiddle] = React.useState();
  let registrationType = localStorage.getItem('registrationType');

  useEffect(() => {
    init();
  }, []);
  const init = async () => {
    try {
      const url = `/moh_manager/all/specialties`;
      const response = await apiService.get(url); // Your API endpoint
      setPractitionerLevel(
        response.data.map((item) => ({ value: item.name, label: item.name }))
      );
    } catch (error) {}
  };
  const handleClick = async (
    tabNumber,
    validateForm,
    setTouched,
    setFieldTouched
  ) => {
    if (tabNumber > selectedTab) {
      const errors = await validateForm();
      Object.keys(errors).forEach((field) => {
        setFieldTouched(field, true);
      });

      if (Object.keys(errors).length === 0) {
        let tab = 1;
        const fieldsInCurrentTab = getFieldsForTab(tab);
        fieldsInCurrentTab.forEach((field) => {
          setFieldTouched(field, false); // Reset the touched state for each field in the tab
        });

        setSelectedTab(tabNumber);
      }
    } else {
      let tab = 1;
      const fieldsInCurrentTab = getFieldsForTab(tab);

      fieldsInCurrentTab.forEach((field) => {
        setFieldTouched(field, false); // Reset the touched state for each field in the tab
      });

      setSelectedTab(tabNumber);
    }
  };
  const getFieldsForTab = (tabNumber) => {
    // You would have a logic to return the fields associated with the tab
    // This is just an example, assuming tabs are numbered and you have a field map:

    const tabFields = {
      1: [
        'licenseNumber',
        'licenseExpiryDate',
        'practitionerType',
        'practitionerLevels',
        'firstArabicName',
        'lastArabicName',
        'firstName',
        'lastName',
        'email',
        'nationality',
        'identityType',
        'identityNumber',
        'dateOfBirth',
        'placeOfBirth',
        'gender',
        'phoneNumber',
        'currentJobOrganization',
        'currentJobTitle',
        'siteIds',
        'medicalSpecialties',
        'educationDocument',
        'experienceDocument',
        'practitionerSpecialtiesDocuments',
      ], // Example for tab 1
    };

    return tabFields[tabNumber] || []; // Default to empty array if no fields for that tab
  };
  const baseSchema = Yup.object({
    licenseNumber: Yup.string()
      .min(8, 'SCFHS License Number must be at least 8 characters')
      .max(15, 'SCFHS License Number must be at most 15 characters')
      .required('SCFHS License Number is required'),
    licenseExpiryDate: Yup.date().required(
      'SCFHS License Expiry Date is required'
    ),

    practitionerType: Yup.string().test(
      'is-valid-practitionerType',
      function (value) {
        if (registrationType !== 'External') {
          if (!value) {
            return this.createError({
              message:
                'Practitioner Type is required for external practitioners',
            });
          }
        }
        return true;
      }
    ),

    practitionerLevels: Yup.string().test(
      'is-valid-practitionerLevel',
      function (value) {
        if (registrationType !== 'External') {
          if (!value) {
            return this.createError({
              message:
                'Practitioner Level is required for external practitioners',
            });
          }
        }
        return true;
      }
    ),

    firstArabicName: Yup.string().test(
      'is-valid-firstArabicName',
      function (value) {
        if (registrationType !== 'External') {
          if (!value) {
            return this.createError({
              message:
                'First Arabic Name is required. Only Arabic characters are allowed.',
            });
          }
        }
        return true;
      }
    ),

    lastArabicName: Yup.string().test(
      'is-valid-lastArabicName',
      function (value) {
        if (registrationType !== 'External') {
          if (!value) {
            return this.createError({
              message:
                'Last Arabic Name is required. Only Arabic characters are allowed.',
            });
          }
        }
        return true;
      }
    ),
  });
  const tabTwoSchema = Yup.object({
    firstName: Yup.string().required(
      'First Name is required. Only English letters are allowed.'
    ),

    lastName: Yup.string().required(
      'Last Name is required.  Only English letters are allowed.'
    ),
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required')
      .matches(
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.(com|com\.sa)$/,
        'Email must end with .com or .com.sa'
      ),
    nationality: Yup.string().required('Nationality is required'),
    identityType: Yup.string().required('Identity Type is required'),

    identityNumber: Yup.string()
      .test('identityTypeValidation', function (value) {
        const { identityType } = this.parent; // Access the parent object (Formik values)

        switch (identityType) {
          // Border Number validation: 10-digit number, starting with either 3 or 4
          case 'Border Number':
            if (!/^\d{10}$/.test(value)) {
              return this.createError({
                message: 'Border Number must be exactly 10 digits',
              });
            }
            if (!/^[34]/.test(value)) {
              return this.createError({
                message: 'Border Number must start with 3 or 4',
              });
            }
            return true;

          // Permanent Resident validation: Minimum 10 digits, starting with 2
          case 'Permanent Resident':
            if (!/^\d{10,}$/.test(value)) {
              return this.createError({
                message: 'Permanent Resident number must be at least 10 digits',
              });
            }
            if (!value.startsWith('2')) {
              return this.createError({
                message: 'Permanent Resident number must start with 2',
              });
            }
            return true;

          // Passport validation: Minimum 5 characters, maximum 30, containing letters and numbers
          case 'Passport':
            if (!/^[a-zA-Z0-9]{5,30}$/.test(value)) {
              return this.createError({
                message:
                  'Passport number must be between 5 and 30 characters and contain letters and numbers',
              });
            }
            return true;

          // National Number validation: Exactly 10 digits, starting with 1
          case 'National Number':
            if (!/^\d{10}$/.test(value)) {
              return this.createError({
                message: 'National Number must be exactly 10 digits',
              });
            }
            if (!value.startsWith('1')) {
              return this.createError({
                message: 'National Number must start with 1',
              });
            }
            return true;

          // Default: No validation for unspecified identity types
          default:
            return true;
        }
      })
      .required('Identity Number is required'),

    dateOfBirth: Yup.string()
      .required('Date of Birth is required')
      .test('min-age', 'You must be at least 20 years old', function (value) {
        if (!value) return false; // Ensures the value exists
        const today = new Date();
        const selectedDate = new Date(value);
        const ageDifference = today.getFullYear() - selectedDate.getFullYear();
        const monthDifference = today.getMonth() - selectedDate.getMonth();
        const dayDifference = today.getDate() - selectedDate.getDate();

        // Adjust age if the current date is before the selected birthdate in the year
        if (
          monthDifference < 0 ||
          (monthDifference === 0 && dayDifference < 0)
        ) {
          return ageDifference - 1 >= 20;
        }
        return ageDifference >= 20;
      }),
    placeOfBirth: Yup.string().required('Place Of Birth is required'),
    gender: Yup.string().required('Gender is required'),
    phoneNumber: Yup.string()
      .length(12, 'Phone number must be exactly 12 digits')
      .required('Phone number is required'),
  });
  const tabThreeSchema = Yup.object({
    currentJobOrganization: Yup.string().required(
      'Current Job Organization is required'
    ),
    currentJobTitle: Yup.string().required('Current Job Title is required'),
    siteIds: Yup.array()
      .min(1, 'At least one preffered hospital is required') // Ensure at least one file is uploaded
      .of(Yup.mixed().required('A preffered hospital is required')),
    medicalSpecialties: Yup.array()
      .min(1, 'At least one Medical Specialty is required') // Ensure at least one file is uploaded
      .of(Yup.mixed().required('A Specialty is required')),
  });
  const tabFourSchema = Yup.object({
    educationDocument: Yup.array()
      .min(1, 'At least one document is required') // Ensure at least one file is uploaded
      .of(Yup.mixed().required('A file is required')),
    experienceDocument: Yup.array()
      .min(1, 'At least one document is required') // Ensure at least one file is uploaded
      .of(Yup.mixed().required('A file is required')),
    practitionerSpecialtiesDocuments: Yup.array()
      .min(1, 'At least one document is required') // Ensure at least one file is uploaded
      .of(Yup.mixed().required('A file is required')),
  });
  const getValidationSchema = (selectedTab) => {
    if (selectedTab === 2) {
      return tabTwoSchema;
    } else if (selectedTab === 3) {
      return tabThreeSchema;
    } else if (selectedTab === 4) {
      return tabFourSchema;
    }
    return baseSchema;
  };
  const uploadFiles = async (formData2) => {
    const response = await axios.post(
      'https://micro-helper.ascend.com.sa/minio/uploads',
      formData2,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: '*/*',
        },
      }
    );
    return response;
  };
  const handleSubmit = async (values) => {
    setLoading(true);
    // const medicalIds = values?.medical?.map(item => item._id);
    const medicalSpecialties = values?.medicalSpecialties?.map(
      (item) => item._id
    );
    const siteIds = values?.siteIds?.map((item) => item.value);

    const originalEducationDocuments = [...values?.educationDocument];
    const originalExperienceDocuments = [...values?.experienceDocument];
    const originalPractitionerSpecialtiesDocuments = [
      ...values?.practitionerSpecialtiesDocuments,
    ];
    const originalRequestAttachments = [...values?.requestAttachments];
    const originalMedical = values?.medical ? [...values?.medical] : [];
    const originalMedicalSpecialties = [...values?.medicalSpecialties];
    const originalSiteIds = [...values?.siteIds];

    const url = formData ? '/physician/update' : '/physician/registerPhysician';

    if (values.educationDocument?.length) {
      let isUpload = false;
      let fileList = [];
      const formDataFile = new FormData();
      formDataFile.append('project', 'visitingdoctor');
      values.educationDocument.forEach((file) => {
        if (typeof file === 'string') {
          fileList.push(file);
        } else {
          formDataFile.append('files', file); // Append each file to formData
          isUpload = true;
        }
      });
      if (isUpload) {
        const response = await uploadFiles(formDataFile);
        if (response) {
          values.educationDocument = [...fileList, ...response.data.paths];
        } else {
          throw response.data;
        }
      }
    }
    if (values.experienceDocument?.length) {
      let isUpload = false;
      let fileList = [];
      const formDataFile = new FormData();
      formDataFile.append('project', 'visitingdoctor');
      values.experienceDocument.forEach((file) => {
        if (typeof file === 'string') {
          fileList.push(file);
        } else {
          formDataFile.append('files', file); // Append each file to formData
          isUpload = true;
        }
      });
      if (isUpload) {
        const response = await uploadFiles(formDataFile);
        if (response) {
          values.experienceDocument = [...fileList, ...response.data.paths];
        } else {
          throw response.data;
        }
      }
    }
    if (values.practitionerSpecialtiesDocuments?.length) {
      let isUpload = false;
      let fileList = [];
      const formDataFile = new FormData();
      formDataFile.append('project', 'visitingdoctor');
      values.practitionerSpecialtiesDocuments.forEach((file) => {
        if (typeof file === 'string') {
          fileList.push(file);
        } else {
          formDataFile.append('files', file); // Append each file to formData
          isUpload = true;
        }
      });
      if (isUpload) {
        const response = await uploadFiles(formDataFile);
        if (response) {
          values.practitionerSpecialtiesDocuments = [
            ...fileList,
            ...response.data.paths,
          ];
        } else {
          throw response.data;
        }
      }
    }
    if (values.requestAttachments?.length) {
      let isUpload = false;
      let fileList = [];
      const formDataFile = new FormData();
      formDataFile.append('project', 'visitingdoctor');
      values.requestAttachments.forEach((file) => {
        if (typeof file === 'string') {
          fileList.push(file);
        } else {
          formDataFile.append('files', file); // Append each file to formData
          isUpload = true;
        }
      });
      if (isUpload) {
        const response = await uploadFiles(formDataFile);
        if (response) {
          values.requestAttachments = [...fileList, ...response.data.paths];
        } else {
          throw response.data;
        }
      }
    }

    if (formData) {
      values.id = formData._id; // Append the _id from formData to values
      values.actionStatus = 'pending';
      // values.medical = medicalIds;
      values.medicalSpecialties = medicalSpecialties;
      values.siteIds = siteIds;
    } else {
      // values.medical = medicalIds;
      values.medicalSpecialties = medicalSpecialties;
      values.is_saudi = registrationType;
      values.siteIds = siteIds;
    }

    try {
      const response = await apiService.post(url, values);

      // Check if the response contains a specific message
      if (response?.message === 'Physician created, but failed to send OTP') {
        toast.success(
          'Physician created successfully, but OTP failed to send.',
          { toastId: 'i1' }
        );
      } else {
        toast.success('Request Submitted Successfully', { toastId: 'i21' });
        setTimeout(() => {
          navigate('/');
        }, 1000);
      }
      setLoading(false);
    } catch (error) {
      // If the error contains a specific message, handle it accordingly
      if (error.message === 'Request failed with status code 500') {
        toast.success('Request Submitted Successfully', { toastId: '2' });
        setTimeout(() => {
          navigate('/');
        }, 2000);
        setLoading(false);
      } else {
        values.educationDocument = originalEducationDocuments;
        values.experienceDocument = originalExperienceDocuments;
        values.practitionerSpecialtiesDocuments =
          originalPractitionerSpecialtiesDocuments;
        values.requestAttachments = originalRequestAttachments;
        values.medical = originalMedical;
        values.medicalSpecialties = originalMedicalSpecialties;
        values.siteIds = originalSiteIds;
        setLoading(false);
        toast.error(
          `Error: ${error?.response?.data?.message || 'Unexpected Error'}`,
          { toastId: '3' }
        );
      }
    }

    setLoading(false);
  };

  const urlParams = new URLSearchParams(window.location.search);
  const physicianId = urlParams.get('physician_id');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const url = `/physician/showPhysician/${physicianId}`;
        const response = await apiService.get(url); // Your API endpoint

        setFormData(response.physician);

        registrationType = response?.physician?.user?.is_saudi;
      } catch (error) {}
    };

    if (physicianId) {
      fetchData();
    }
  }, [physicianId]);

  if (!formData && physicianId) {
    return <div></div>;
  }
  return (
    <>
      <div className="p-8 overflow-hidden h-full">
        <div className="flex justify-between pb-5">
          <div className="flex">
            <div style={{ paddingTop: '5px' }}>
              <img
                src={arrow}
                alt="logo"
                style={{ cursor: 'pointer' }}
                onClick={() => navigate('/')}
              />
            </div>
            <div
              style={{ width: '392px', height: '60px', paddingLeft: '35px' }}
            >
              <h5 className="h5-title">Registration As Physician</h5>
              <p className="paragraph-medium">
                Enter your details to Register.
              </p>
            </div>
          </div>
          <div>
            <img src={Header} alt="logo" />
          </div>
        </div>
        <div className="md:flex">
          <Formik
            initialValues={{
              licenseNumber: formData?.licenseNumber || '',
              licenseExpiryDate: formData?.licenseExpiryDate || '',
              healthPractitionerStatus:
                formData?.healthPractitionerStatus || '',
              practitionerType: formData?.practitionerType || '',
              practitionerLevels: formData?.practitionerLevels || '',
              practitionerSpecialties: formData?.practitionerSpecialties || '',
              firstArabicName: formData?.firstArabicName || '',
              middleArabicName: formData?.middleArabicName || '',
              lastArabicName: formData?.lastArabicName || '',
              firstName: formData?.user?.firstName || '',
              middleName: formData?.user?.middleName || '',
              lastName: formData?.user?.lastName || '',
              nationality: formData?.nationality || '',
              identityType: formData?.identityType || '',

              identityNumber: formData?.identityNumber || '',
              dateOfBirth: formData?.dateOfBirth || '',
              placeOfBirth: formData?.placeOfBirth || '',
              gender: formData?.gender || '',
              email: formData?.user?.email || '',
              phoneNumber: formData?.user?.phoneNumber || '',
              currentJobOrganization: formData?.currentJobOrganization || '',
              currentJobTitle: formData?.currentJobTitle || '',
              medicalSpecialties:
                formData?.medicalSpecialties ||
                formData?.related_medical_specialties ||
                [],
              educationDocument: formData?.educationDocument || [],
              experienceDocument: formData?.experienceDocument || [],
              practitionerSpecialtiesDocuments:
                formData?.practitionerSpecialtiesDocuments || [],
              requestAttachments: formData?.requestAttachments || [],
              siteIds:
                formData?.sites?.map((site) => ({
                  value: site._id,
                  label: site.name,
                })) || [],
            }}
            validationSchema={getValidationSchema(selectedTab)}
            validateOnBlur={false}
            onSubmit={(values) => {
              handleSubmit(values);
              // Handle form submission logic here
            }}
          >
            {({
              values,
              handleChange,
              handleBlur,
              validateForm,
              errors,
              touched,
              setTouched,
              setFieldTouched,
              handleSubmit,
              setFieldValue,
              setFieldError,
            }) => (
              <>
                <ul
                  className="flex-column space-y space-y-4 text-sm font-medium text-gray-500  md:me-4 mb-4 md:mb-0"
                  id="default-tab"
                  role="tablist"
                >
                  {[
                    { id: 1, label: 'Basic Information' },
                    { id: 2, label: 'Personal Information' },
                    { id: 3, label: 'Professional Information' },
                    { id: 4, label: 'Document Upload' },
                    { id: 5, label: 'Complete' },
                  ].map((tab) => (
                    <li
                      key={tab.id}
                      className="w-full lg:w-[301px] xl:w-[301px] md:w-[301px] "
                      role="presentation"
                    >
                      <button
                        onClick={() =>
                          handleClick(
                            tab.id,
                            validateForm,
                            setTouched,
                            setFieldTouched
                          )
                        }
                        aria-selected={selectedTab === tab.id}
                        role="tab"
                        aria-controls={`tab-${tab.id}`}
                        className={`inline-flex h-[40px] items-center px-4 py-3 rounded-lg w-full ${
                          selectedTab === tab.id
                            ? 'bg-white text-black shadow-[0px_2px_4px_0px_#1B1C1D0A]'
                            : 'bg-gray-50  '
                        }`}
                      >
                        <div
                          className={`${
                            selectedTab === tab.id ? 'circleSelected' : 'circle'
                          }`}
                        >
                          {tab.id}
                        </div>
                        {tab.label}
                      </button>
                    </li>
                  ))}
                </ul>
                <div id="default-tab-content w-full" style={{ width: '100%' }}>
                  <Form onSubmit={handleSubmit}>
                    {selectedTab === 1 && (
                      <div
                        className=" text-medium text-gray-500   rounded-lg w-full"
                        id="profile"
                        role="tabpanel"
                        aria-labelledby="profile-tab"
                      >
                        <div className="flex items-center space-x-1 mb-4">
                          <div className="pl-4">
                            <img
                              src={LicenseIcon}
                              alt="License Icon"
                              className="w-4 h-4"
                            />
                          </div>
                          <h3 className="label-medium pt-1">
                            License Information
                          </h3>
                        </div>
                        <div className="border-t border-l pb-[67px]">
                          <div className=" pt-1 ml-4 ">
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                              <div className="lg:col-span-2">
                                <div>
                                  <CustomINput
                                    type={'text'}
                                    label="SCFHS License Number"
                                    className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[12px]"
                                    width=" w-full"
                                    height="h-[40px]"
                                    labelClass={`label-small`}
                                    isRequired={true}
                                    isRequiredClass="text-[#2D9F75]"
                                    icon={<img src={Icon} alt="logo" />}
                                    position={'right-4'}
                                    name="licenseNumber"
                                    value={values.licenseNumber}
                                    onChange={(e) => {
                                      setFieldValue(
                                        'licenseNumber',
                                        e?.target?.value
                                      );
                                    }}
                                  />
                                  {errors.licenseNumber &&
                                    touched.licenseNumber && (
                                      <div className="text-red-500 text-[12px]">
                                        {errors.licenseNumber}
                                      </div>
                                    )}
                                </div>
                              </div>
                              <div>
                                <div>
                                  <CustomDatepicker
                                    className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[11px]"
                                    width="w-full"
                                    placement="down"
                                    height="h-[40px]"
                                    label="SCFHS License Expiry Date"
                                    labelClass={`label-small`}
                                    isRequired={true}
                                    isRequiredClass="text-[#2D9F75]"
                                    name="licenseExpiryDate"
                                    value={values.licenseExpiryDate}
                                    minDate={new Date()}
                                    onChange={(e) => {
                                      setFieldValue('licenseExpiryDate', e);

                                      const currentDate = new Date();
                                      const date = new Date(currentDate);
                                      const dateString = date
                                        .toISOString()
                                        .split('T')[0];
                                      if (e >= dateString) {
                                        setCheckDisabled(true);
                                      } else {
                                        setCheckDisabled(false);
                                      }
                                    }}
                                  />
                                  {errors.licenseExpiryDate &&
                                    touched.licenseExpiryDate && (
                                      <div className="text-red-500 text-[12px]">
                                        {errors.licenseExpiryDate}
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="pt-6 ml-4">
                            <div className="flex items-center space-x-1 mb-4">
                              <div className="">
                                <img
                                  src={shatho}
                                  alt="License Icon"
                                  className="w-6 h-6 "
                                />
                              </div>
                              <h3 className=" label-medium pt-1">
                                Practitioner Information
                              </h3>
                            </div>
                            <hr />
                            <div className="pt-1 mt-4">
                              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                                <div>
                                  <CustomDropDown
                                    label="Practitioner Type"
                                    className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none rounded-[11px]"
                                    disabled={registrationType !== 'Internal'}
                                    height="h-[40px]"
                                    labelClass={`label-small`}
                                    isRequired={true}
                                    isRequiredClass="text-[#2D9F75]"
                                    name="practitionerType"
                                    value={values.practitionerType}
                                    zIndex={'99999'}
                                    onChange={(e) => {
                                      setFieldValue('practitionerType', e);
                                    }}
                                    options={practitionerType}
                                  />
                                  {errors.practitionerType &&
                                    touched.practitionerType && (
                                      <div className="text-red-500 text-[12px]">
                                        {errors.practitionerType}
                                      </div>
                                    )}
                                </div>
                                <div>
                                  <CustomDropDown
                                    className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none  rounded-[11px]"
                                    label="Practitioner Levels"
                                    height="h-[40px]"
                                    disabled={registrationType !== 'Internal'}
                                    labelClass={`label-small`}
                                    zIndex={'99999'}
                                    isRequired={true}
                                    isRequiredClass="text-[#2D9F75]"
                                    name={'practitionerLevels'}
                                    value={values.practitionerLevels}
                                    onChange={(e) => {
                                      setFieldValue('practitionerLevels', e);
                                    }}
                                    options={practitionerLevel}
                                  />
                                  {errors.practitionerLevels &&
                                    touched.practitionerLevels && (
                                      <div className="text-red-500 text-[12px]">
                                        {errors.practitionerLevels}
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {registrationType === 'Internal' && (
                            <div className="pt-6 ml-4">
                              <div className="flex items-center space-x-1 mb-4">
                                <div className="">
                                  <img
                                    src={Arabic}
                                    alt="License Icon"
                                    className="w-5 h-5"
                                  />
                                </div>
                                <h3 className=" label-medium pt-1">
                                  Arabic Name
                                </h3>
                              </div>
                              <hr />
                              <div className="pt-1 mt-4">
                                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                                  <div>
                                    <CustomINput
                                      label="First Arabic Name"
                                      className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[12px]"
                                      height="h-[40px]"
                                      labelClass={`label-small`}
                                      isRequired={true}
                                      isRequiredClass="text-[#2D9F75]"
                                      name="firstArabicName"
                                      value={values.firstArabicName}
                                      onChange={(e) => {
                                        const arabicRegex =
                                          /^[\u0600-\u06FF\s]*$/;
                                        if (arabicRegex.test(e.target.value)) {
                                          setFieldValue(
                                            'firstArabicName',
                                            e.target.value
                                          );
                                          setFieldError('firstArabicName', '');
                                        } else {
                                          setFieldError(
                                            'firstArabicName',
                                            'Only Arabic characters are allowed.'
                                          );
                                        }
                                      }}
                                    />
                                    {errors.firstArabicName &&
                                      touched.firstArabicName && (
                                        <div className="text-red-500 text-[12px]">
                                          {errors.firstArabicName}
                                        </div>
                                      )}
                                  </div>
                                  <div>
                                    <CustomINput
                                      className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[12px]"
                                      height="h-[40px]"
                                      label="Middle Arabic Name"
                                      labelClass={`label-small`}
                                      isRequiredClass="text-[#2D9F75]"
                                      name="middleArabicName"
                                      value={values.middleArabicName}
                                      onChange={(e) => {
                                        const { value } = e.target;
                                        if (
                                          /^[\u0600-\u06FF\s]*$/.test(value)
                                        ) {
                                          setFieldValue(
                                            'middleArabicName',
                                            value
                                          ); // Set valid Arabic input
                                          setMiddle(null);
                                        } else {
                                          setMiddle(
                                            'Only Arabic characters are allowed.'
                                          );
                                          setFieldValue('middleArabicName', ''); // Reset invalid input
                                        }
                                        // Trigger validation explicitly
                                      }}
                                    />
                                    {errors.middleArabicName &&
                                      touched.middleArabicName && (
                                        <div className="text-red-500 text-[12px]">
                                          {errors.middleArabicName}
                                        </div>
                                      )}
                                    <div className="text-red-500 text-[12px]">
                                      {middle}
                                    </div>
                                  </div>

                                  <div>
                                    <CustomINput
                                      label="Last Arabic Name"
                                      className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[12px]"
                                      labelClass={`label-small`}
                                      isRequired={true}
                                      height="h-[40px]"
                                      isRequiredClass="text-[#2D9F75]"
                                      name="lastArabicName"
                                      value={values.lastArabicName}
                                      onChange={(e) => {
                                        const arabicRegex =
                                          /^[\u0600-\u06FF\s]*$/;
                                        if (arabicRegex.test(e.target.value)) {
                                          setFieldValue(
                                            'lastArabicName',
                                            e.target.value
                                          );
                                          setFieldError('lastArabicName', '');
                                        } else {
                                          setFieldError(
                                            'lastArabicName',
                                            'Only Arabic characters are allowed.'
                                          );
                                        }
                                      }}
                                    />
                                    {errors.lastArabicName &&
                                      touched.lastArabicName && (
                                        <div className="text-red-500 text-[12px]">
                                          {errors.lastArabicName}
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="flex justify-end items-center pt-8">
                          <button
                            type="button"
                            aria-selected={selectedTab === 2 ? 'true' : 'false'}
                            onClick={() =>
                              handleClick(
                                2,
                                validateForm,
                                setTouched,
                                setFieldTouched
                              )
                            }
                            id="dashboard-tab"
                            data-tabs-target="#dashboard"
                            role="tab"
                            aria-controls="dashboard"
                            class="text-white bg-[#007A63] flex justify-center items-center  focus:ring-4 focus:outline-none w-[128px] h-[40px] font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center"
                          >
                            Next
                            <img
                              src={IconArrow}
                              alt="logo"
                              style={{ paddingLeft: '12px' }}
                            />
                          </button>
                        </div>
                      </div>
                    )}
                    {selectedTab === 2 && (
                      <>
                        <PersonalInfo
                          values={values} // Pass Formik values
                          handleChange={handleChange} // Pass Formik handleChange
                          handleBlur={handleBlur} // Pass Formik handleBlur
                          errors={errors} // Pass Formik errors
                          touched={touched} // Pass Formik touched
                          handleClick={handleClick} // Pass handleClick
                          selectedTab={selectedTab} // Pass selectedTab
                          validateForm={validateForm}
                          setTouched={setTouched}
                          setFieldTouched={setFieldTouched}
                          setFieldValue={setFieldValue}
                          setFieldError={setFieldError}
                        />
                      </>
                    )}
                    {selectedTab === 3 && (
                      <>
                        <Professional
                          setFieldValue={setFieldValue}
                          values={values} // Pass Formik values
                          handleChange={handleChange} // Pass Formik handleChange
                          handleBlur={handleBlur} // Pass Formik handleBlur
                          errors={errors} // Pass Formik errors
                          touched={touched} // Pass Formik touched
                          handleClick={handleClick} // Pass handleClick
                          selectedTab={selectedTab} // Pass selectedTab
                          validateForm={validateForm}
                          setTouched={setTouched}
                          setFieldTouched={setFieldTouched}
                        />
                      </>
                    )}
                    {selectedTab === 4 && (
                      <>
                        <DocumentUpload
                          setFieldValue={setFieldValue}
                          values={values} // Pass Formik values
                          handleChange={handleChange} // Pass Formik handleChange
                          handleBlur={handleBlur} // Pass Formik handleBlur
                          errors={errors} // Pass Formik errors
                          touched={touched} // Pass Formik touched
                          handleClick={handleClick} // Pass handleClick
                          selectedTab={selectedTab} // Pass selectedTab
                          validateForm={validateForm}
                          setTouched={setTouched}
                          setFieldTouched={setFieldTouched}
                        />
                      </>
                    )}
                    {selectedTab === 5 && (
                      <>
                        <CompleteForm
                          loading={loading}
                          values={values} // Pass Formik values
                          handleChange={handleChange} // Pass Formik handleChange
                          handleBlur={handleBlur} // Pass Formik handleBlur
                          errors={errors} // Pass Formik errors
                          touched={touched} // Pass Formik touched
                          handleClick={handleClick} // Pass handleClick
                          selectedTab={selectedTab} // Pass selectedTab
                          validateForm={validateForm}
                          setTouched={setTouched}
                          setFieldTouched={setFieldTouched}
                          registrationType={registrationType}
                        />
                      </>
                    )}
                  </Form>
                </div>
              </>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default PhysicianForm;
